var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price"},[_c('span',{staticClass:"price__number",domProps:{"innerHTML":_vm._s(_vm.formattedPrice)}}),_vm._v(" "),_c('span',{staticClass:"price__currency"},[_vm._v(_vm._s(_vm.currencyName))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }